<template>
    <NuxtLayout name="default">
        <div class="flex flex-col w-full px-8">
            <layout-maintenance class="mt-12" />

            <div class="flex justify-center w-full mx-auto flex-1 auth-width">
                <!-- Small alert that some actions might not be available -->
                <layout-maintenance class="mb-12" />

                <slot />
            </div>

            <layout-footer />
        </div>
    </NuxtLayout>
</template>

<style scoped>
@reference "../assets/css/app.css";

.auth-width {
    @apply max-w-md;
}

:deep(.auth-width:has(.layout-auth-wide)) {
    @apply max-w-lg;
}
</style>
